<div class="mt-3">
  @if (showHeader) {
    <label for="filter">{{'workTask.filter' | translate}}</label>
    <p class="text-muted py-3" style="font-size: 14px;">{{'workTask.f_description' | translate}}</p>
  }

  <div class="d-flex justify-content-between mb-3">

    <button mat-button class="secondary-gray-button" [matMenuTriggerFor]="addRootMenu" [disabled]="disabled">
      <mat-icon>add_circle</mat-icon> {{'workTask.f_add' | translate}}
    </button>

    @if (_predicates.length > 0) {
      <button mat-button class="secondary-gray-button" (click)="deleteAll()" [disabled]="disabled">
        <mat-icon class="material-symbols-outlined" style="color:red;">delete</mat-icon> {{'predicateFilter.removeAll' | translate}}
      </button>
    }

  </div>

  <mat-menu #addRootMenu="matMenu">
    @for (ft of filterTypes; track ft) {
      <button mat-menu-item (click)="addFilter(ft.type)">
        {{ft.translation | translate}}
      </button>
    }
  </mat-menu>

  @if (_predicates.length > 0) {
    <div id="tree-section">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="predicate-tree w-100 m-auto shadow-sm">
        <!-- Group node (and/or) -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasGroup">
          <div class="mat-tree-node border-bottom">
            <button mat-icon-button matTreeNodeToggle>
              <mat-icon class="mat-icon-rtl-mirror">{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
            <div class="d-flex flex-row justify-content-between align-items-center w-100 ps-2">
              <div class="d-flex align-items-center">
                @if ($any(node).and) {
                  <span style="color:black; font-weight: 500;">{{'predicateFilter.allOf' | translate}}</span>
                }
                @if ($any(node).or) {
                  <span style="color:black; font-weight: 500;">{{'predicateFilter.anyOf' | translate}}</span>
                }
                <span class="text-muted ms-2" style="font-size: 12px;">
                  ({{($any(node).and || $any(node).or || []).length}})
                </span>
              </div>
              <div>
                <button mat-icon-button style="color:var(--warmOrange);" [matMenuTriggerFor]="editGroupMenu" [disabled]="disabled">
                  <mat-icon>edit</mat-icon>
                </button>
                <mat-menu #editGroupMenu="matMenu">
                  <button mat-menu-item (click)="toggleGroupKind($any(node), 'and')">{{'predicateFilter.allOf' | translate}}</button>
                  <button mat-menu-item (click)="toggleGroupKind($any(node), 'or')">{{'predicateFilter.anyOf' | translate}}</button>
                </mat-menu>
                <button mat-icon-button style="color:var(--warmOrange);" [matMenuTriggerFor]="addNodeMenu" [disabled]="disabled">
                  <mat-icon>add_circle</mat-icon>
                </button>
                <mat-menu #addNodeMenu="matMenu">
                  @for (ft of filterTypes; track ft) {
                    <button mat-menu-item (click)="addFilterToNode(ft.type, $any(node))">
                      {{ft.translation | translate}}
                    </button>
                  }
                </mat-menu>
                <button mat-icon-button style="color: red;" (click)="deleteNode(node)" [disabled]="disabled">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </div>
            </div>
          </div>
          <div [class.predicate-tree-invisible]="!treeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
        <!-- Leaf node (simple filter / comparison) -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: isComparison">
          <div class="mat-tree-node border-bottom">
            <div class="d-flex flex-row justify-content-between align-items-center w-100 ps-2" style="padding-left: 40px;">
              <div class="d-flex flex-column py-1" (click)="editNode(node)" style="cursor: pointer;">
                <span>{{$any(node).displayName || $any(node).field}}</span>
                <label class="text-muted" style="font-size: 12px; cursor: pointer;">
                  {{$any(node).field}} ({{getOperatorText($any(node).operator) | translate}}) {{formatFilterValue(node)}}
                </label>
              </div>
              <div>
                <button mat-icon-button style="color:var(--warmOrange);" (click)="editNode(node)" [disabled]="disabled">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button style="color: red;" (click)="deleteNode(node)" [disabled]="disabled">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </div>
            </div>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </div>
  }
</div>
